import { theme } from '@arnold/common';
import styled from '@emotion/styled';

export const TableContainer = styled.div`
  margin-top: ${theme.spacing.d};
`;
